import React from 'react';
import {
  BookIcon,
  CalculatorIcon,
  ClockOutlineIcon,
  DocumentIcon,
  DownloadIcon,
  MapIcon,
  ShieldIcon,
  TruckIcon,
} from 'components/common/Icons';

/**
 * Icons an editor can pick for a card in the admin panel.
 * Keep in sync with USEFUL_ICONS in backend/constants/useful.ts.
 */
export const USEFUL_ICONS = {
  document: DocumentIcon,
  download: DownloadIcon,
  truck: TruckIcon,
  shield: ShieldIcon,
  calculator: CalculatorIcon,
  book: BookIcon,
  map: MapIcon,
  clock: ClockOutlineIcon,
} as const;

export type UsefulIconKey = keyof typeof USEFUL_ICONS;

interface UsefulIconProps {
  icon?: string;
  className?: string;
  size?: number;
}

/** Draws the icon of a material, falling back to the document sheet for an unknown key */
const UsefulIcon: React.FC<UsefulIconProps> = ({ icon, className, size = 24 }) => {
  const Icon = USEFUL_ICONS[icon as UsefulIconKey] ?? USEFUL_ICONS.document;

  return <Icon className={className} size={size} />;
};

export default UsefulIcon;
